"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _notistack = require("notistack");

var _classnames = _interopRequireDefault(require("classnames"));

var _customField = _interopRequireDefault(require("../../../../_common/formik/customField"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _phoneNumber = _interopRequireDefault(require("../../../../_common/textfields/phoneNumber"));

var _placesSearch = _interopRequireDefault(require("../../../placesSearch"));

var _useGoogleMap = _interopRequireDefault(require("../../../hooks/useGoogleMap"));

var _wrong_location_black_48dp = _interopRequireDefault(require("../../../img/wrong_location_black_48dp.svg"));

require("./index.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var DEFAULT_LAT = 30.3079823;
var DEFAULT_LNG = -97.8938278;

var LocationInfo = function LocationInfo(_ref) {
  var _values$address, _values$address2;

  var values = _ref.values,
      setFieldValue = _ref.setFieldValue,
      errors = _ref.errors;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      marker = _useState2[0],
      setMarker = _useState2[1];

  var map = (0, _useGoogleMap.default)(DEFAULT_LAT, DEFAULT_LNG, 13, {}, "map");

  var _useSnackbar = (0, _notistack.useSnackbar)(),
      enqueueSnackbar = _useSnackbar.enqueueSnackbar;

  (0, _react.useEffect)(function () {
    if (map && values.latitude !== -1 && values.longitude !== -1) {
      map.panTo(new google.maps.LatLng(values.latitude, values.longitude));

      if (!marker) {
        var newMarker = new google.maps.Marker({
          position: new google.maps.LatLng(values.latitude, values.longitude),
          map: map
        }); // TODO: Let admins move them?
        // newMarker.addListener('dragend', event => {
        //     setLocation({ latitude: event.latLng.lat(), longitude: event.latLng.lng() })
        // });

        setMarker(newMarker);
      } else {
        marker.setPosition(new google.maps.LatLng(values.latitude, values.longitude));
      }
    }
  }, [map, values.latitude, values.longitude, marker]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "pb-3"
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_customField.default, {
    CustomComponent: _TextField.default,
    name: "name",
    label: "Location Name",
    fullWidth: true,
    inputProps: {
      maxLength: 2500
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "mt-5"
  }, /*#__PURE__*/_react.default.createElement(_customField.default, {
    CustomComponent: _TextField.default,
    name: "description",
    label: "Description",
    fullWidth: true,
    helperText: "Describe the infusion center to potential patients and users of the locator. This will be publically displayed in the locator listing. Please do not put any contact information in this area to limit spam.",
    inputProps: {
      maxLength: 2500
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "mt-5 flex"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex justify-center flex-1"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex-1 flex flex-col"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "font-lato text-lightBlue"
  }, "Location Address"), values.address.line1 ? /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "mt-4 font-medium mb-1"
  }, (_values$address = values.address) === null || _values$address === void 0 ? void 0 : _values$address.line1), /*#__PURE__*/_react.default.createElement("div", {
    className: "mb-3 pr-8"
  }, /*#__PURE__*/_react.default.createElement(_customField.default, {
    CustomComponent: _TextField.default,
    name: "address.line2",
    label: "Address Line 2",
    placeholder: "Suite 102",
    fullWidth: true,
    inputProps: {
      maxLength: 200
    }
  })), /*#__PURE__*/_react.default.createElement("div", null, (_values$address2 = values.address) === null || _values$address2 === void 0 ? void 0 : _values$address2.city, ", ", values.address.stateCode, " ", values.address.zip)) : /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)("mt-4 flex flex-col justify-center items-center pr-6 pt-6", {
      "error": errors === null || errors === void 0 ? void 0 : errors.address,
      "text-gray": !(errors !== null && errors !== void 0 && errors.address)
    })
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("img", {
    src: _wrong_location_black_48dp.default,
    alt: "misisng location"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "text-center px-2 mt-2"
  }, "Search for an Address to the right in order to set this Location's address."))), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex-1"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "mb-4"
  }, /*#__PURE__*/_react.default.createElement(_placesSearch.default, {
    map: map,
    onPlaceSelected: function onPlaceSelected(place) {
      console.log("place", place);

      var streetNumber = _getComponent(place, "street_number");

      var streetName = _getComponent(place, "route");

      var city = _getComponent(place, "locality");

      var state = _getComponent(place, "administrative_area_level_1");

      var zip = _getComponent(place, "postal_code");

      if (streetNumber && city && state && zip) {
        var address = {
          line1: "".concat(streetNumber === null || streetNumber === void 0 ? void 0 : streetNumber.short_name, " ").concat(streetName === null || streetName === void 0 ? void 0 : streetName.short_name),
          line2: '',
          city: city === null || city === void 0 ? void 0 : city.short_name,
          stateCode: state === null || state === void 0 ? void 0 : state.short_name,
          zip: zip === null || zip === void 0 ? void 0 : zip.short_name
        };
        setFieldValue('address', address, false);
        setFieldValue('latitude', place.geometry.location.lat(), false);
        setFieldValue('longitude', place.geometry.location.lng(), false);
      } else {
        enqueueSnackbar("Please choose an Address with a Street Number", {
          variant: "error"
        });
      }
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    id: "map",
    className: "flex-1 h-52"
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex mt-5"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex1 mr-5"
  }, /*#__PURE__*/_react.default.createElement(_customField.default, {
    CustomComponent: _phoneNumber.default,
    name: "phoneNumber",
    label: "Phone",
    type: "phone",
    placeholder: "(555) 555-5555",
    fullWidth: true,
    inputProps: {
      maxLength: 14
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex1"
  }, /*#__PURE__*/_react.default.createElement(_customField.default, {
    CustomComponent: _phoneNumber.default,
    name: "faxNumber",
    label: "Fax",
    type: "phone",
    placeholder: "(555) 555-5555",
    fullWidth: true,
    inputProps: {
      maxLength: 14
    }
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "mt-5"
  }, /*#__PURE__*/_react.default.createElement(_customField.default, {
    CustomComponent: _TextField.default,
    name: "emailAddress",
    label: "Email",
    type: "email",
    placeholder: "someone@gmail.com",
    fullWidth: true,
    helperText: "Locator users won't be able to contact the location through the locator tool contact form unless a location email address is provided.",
    inputProps: {
      maxLength: 200
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "mt-5"
  }, /*#__PURE__*/_react.default.createElement(_customField.default, {
    CustomComponent: _TextField.default,
    name: "url",
    label: "Website",
    placeholder: "https://yoursite.com",
    fullWidth: true // helperText={touched.url && errors.url ? `${errors.url}, e.g. "https://yoursite.com"` : "https://yoursite.com"}
    ,
    inputProps: {
      maxLength: 200
    }
  })));
};

function _getComponent(place, componentName) {
  return place.address_components.find(function (component) {
    return component.types.includes(componentName);
  });
}

var _default = LocationInfo;
exports.default = _default;